import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { translations } from "../lib/translations";
import { Nav } from "../components/sections/Nav";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { Industries } from "../components/sections/Industries";
import { FAQ } from "../components/sections/FAQ";
import { RequestForm } from "../components/sections/RequestForm";
import { Footer } from "../components/sections/Footer";

const TOAST_OPTIONS = { className: "font-body" };

export default function Landing({ lang = "en" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [, setServiceHighlight] = useState(null);
  const [activeService, setActiveService] = useState("outsourcing");
  const t = translations[lang];

  const navigateLang = (target) => {
    if (target === lang) return;
    navigate(`/${target}${location.hash || ""}`);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    const titles = {
      en: "Kadra Talent — Workers without borders",
      uk: "Kadra Talent — Робітники без кордонів",
    };
    const descs = {
      en: "We bring verified international workers to manufacturers in Ukraine and Europe — turnkey and fully legal. Scale production without limits.",
      uk: "Привозимо перевірений іноземний персонал на виробництва в Україні та Європі — під ключ і легально. Масштабування виробництва без обмежень.",
    };
    const url = `https://kadratalent.com/${lang}`;
    document.title = titles[lang] || titles.en;
    const setMeta = (selector, content) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", content);
    };
    setMeta('meta[name="description"]', descs[lang]);
    setMeta('meta[property="og:description"]', descs[lang]);
    setMeta('meta[name="twitter:description"]', descs[lang]);
    setMeta('meta[property="og:title"]', titles[lang]);
    setMeta('meta[name="twitter:title"]', titles[lang]);
    setMeta('meta[property="og:locale"]', lang === "uk" ? "uk_UA" : "en_US");
    setMeta('meta[property="og:url"]', url);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
  }, [lang]);

  const handleServiceSelect = (key) => {
    setActiveService(key);
    setServiceHighlight(key);
    requestAnimationFrame(() => {
      const el = document.getElementById("services");
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    });
    setTimeout(() => setServiceHighlight(null), 2500);
  };

  return (
    <div data-testid="landing-root" style={{ background: "var(--white)" }}>
      <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
      <Nav
        t={t}
        lang={lang}
        navigateLang={navigateLang}
        onServiceSelect={handleServiceSelect}
      />
      <main>
        <Hero t={t} />
        <About t={t} />
        <Services
          t={t}
          activeService={activeService}
          setActiveService={setActiveService}
        />
        <Industries t={t} />
        <FAQ t={t} />
        <RequestForm t={t} lang={lang} />
      </main>
      <Footer t={t} />
    </div>
  );
}
